import { FC } from 'react';
import { TPointSummary } from '../../../mapTypes';

interface IVesselLastPointPopupContentProps {
  info: TPointSummary;
}

const VesselLastPointPopupContent: FC<IVesselLastPointPopupContentProps> = ({ info }) => (
  <>
    <div>
      <span className="font-bold">IMO Number - Name : </span>
      <span>{info?.name}</span>
    </div>
    {info?.reportedDestination && (
      <div>
        <span className="font-bold">Reported Destination : </span>
        <span>{info?.reportedDestination?.toUpperCase()}</span>
      </div>
    )}
    {info?.reportedEta && (
      <div>
        <span className="font-bold">Reported ETA : </span>
        <span>{new Date(info?.reportedEta).toLocaleString()}</span>
      </div>
    )}
  </>
);

export default VesselLastPointPopupContent;
